import { StreamingBanner } from 'src/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/StreamingBanner'
import { ContentInteraction, DiscoverItemInteraction } from '@/services/Analytics/ContentInteractions'
import { HeroBannerData } from '@/services/RecommendedBannerService/types'
import { GenericBanner } from '@/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/GenericBanner'
import { TicketsBanner } from '@/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/TicketsBanner'

type RecommendedBannerProps = {
  banner: HeroBannerData
  itemIndex?: number
  createInteraction?: (banner: HeroBannerData, itemIndex: number) => DiscoverItemInteraction | null
  trackInteraction?: (interaction: ContentInteraction, allowAutoImpression?: boolean) => void
}

export const RecommendedBanner: React.FC<RecommendedBannerProps> = ({
  banner,
  itemIndex = 0,
  createInteraction,
  trackInteraction,
}) => {
  if (banner.type === 'streaming') {
    return (
      <StreamingBanner
        banner={banner}
        itemIndex={itemIndex}
        createInteraction={createInteraction}
        trackInteraction={trackInteraction}
      />
    )
  }

  if (banner.type === 'tickets') {
    return (
      <TicketsBanner
        banner={banner}
        itemIndex={itemIndex}
        createInteraction={createInteraction}
        trackInteraction={trackInteraction}
      />
    )
  }

  if (banner.type === 'generic') {
    return (
      <GenericBanner
        banner={banner}
        itemIndex={itemIndex}
        createInteraction={createInteraction}
        trackInteraction={trackInteraction}
      />
    )
  }

  return null
}
